'use client'

import { Delivery } from '@/screens/Delivery'

import { InfoPageLayout } from '@/shared/lib/layouts/InfoPageLayout'

const DeliveryPageContent = () => {
	return (
		<>
			<InfoPageLayout>
				<Delivery />
			</InfoPageLayout>
		</>
	)
}

export function DeliveryClient() {
	return <DeliveryPageContent />
}
